import { DESKTOP, giveColor, MOBILE, TABLET } from 'utils/styles'
import './fonts/fonts.css'
import {
  MENU_ICON_SIZE_DESKTOP,
  MENU_ICON_SIZE_MOBILE,
  MENU_ICON_SIZE_TABLET,
  SIZE_MULTIPLIER_SMALLER,
} from './utils/helpers'
import { typography } from './utils/typographyHelper'

const projectTheme = {
  typography: {},
  palette: {
    white: (opacity?: number) => giveColor(255, 255, 255, opacity),
    black: (opacity?: number) => giveColor(0, 0, 0, opacity),
    secondary: {
      main: '#2e2e2e',
      dark: 'rgba(46,46,46, 0.7)',
      light: 'rgb(46,46,46, 0.3)',
    },
    primary: {
      main: '#894118',
      dark: 'rgba(137, 65, 24, 0.7)',
      light: 'rgba(137, 65, 24, 0.3)',
    },
    sectionText: {
      desktop: {
        background: 'transparent',
        fontColor: (opacity?: number) => giveColor(255, 255, 255, opacity),
        accentColor: (opacity?: number) => giveColor(0, 0, 0, opacity),
        accentFontColor: (opacity?: number) =>
          giveColor(255, 255, 255, opacity),
      },
      phone: {
        background: giveColor(255, 255, 255, 0.95),
        fontColor: (opacity?: number) => giveColor(0, 0, 0, opacity),
        accentColor: (opacity?: number) => giveColor(0, 0, 0, opacity),
        accentFontColor: (opacity?: number) =>
          giveColor(255, 255, 255, opacity),
      },
    },
    sectionBackground: {
      desktop: {
        background: `linear-gradient(to left, ${giveColor(
          0,
          0,
          0,
          0.9
        )}, ${giveColor(0, 0, 0, 0)})`,
        backgroundReversed: `linear-gradient(to right, ${giveColor(
          0,
          0,
          0,
          0.9
        )}, ${giveColor(0, 0, 0, 0)})`,
        fontColor: (opacity?: number) => giveColor(255, 255, 255, opacity),
        accentColor: (opacity?: number) => giveColor(0, 0, 0, opacity),
        accentFontColor: (opacity?: number) =>
          giveColor(255, 255, 255, opacity),
      },
      phone: {
        background: giveColor(0, 0, 0, 0.95),
        fontColor: (opacity?: number) => giveColor(255, 255, 255, opacity),
        accentColor: (opacity?: number) => giveColor(0, 0, 0, opacity),
        accentFontColor: (opacity?: number) =>
          giveColor(255, 255, 255, opacity),
      },
    },
    cover: {
      desktop: {
        background: `linear-gradient(to bottom, ${giveColor(
          255,
          255,
          255,
          0.1
        )}, ${giveColor(255, 255, 255, 0.2)})`,
        fontColor: (opacity?: number) => giveColor(255, 255, 255, opacity),
        accentColor: (opacity?: number) => giveColor(0, 0, 0, opacity),
        accentFontColor: (opacity?: number) =>
          giveColor(255, 255, 255, opacity),
      },
      phone: {
        background: `linear-gradient(to bottom, ${giveColor(
          255,
          255,
          255,
          0.3
        )}, ${giveColor(255, 255, 255, 0.6)})`,
        fontColor: (opacity?: number) => giveColor(255, 255, 255, opacity),
        accentColor: (opacity?: number) => giveColor(0, 0, 0, opacity),
        accentFontColor: (opacity?: number) =>
          giveColor(255, 255, 255, opacity),
      },
    },
    // Videogalerie, Chronik, etc.
    materials: {
      desktop: {
        background: giveColor(255, 255, 255, 1.0),
        fontColor: (opacity?: number) => giveColor(0, 0, 0, opacity),
        accentColor: (opacity?: number) => giveColor(0, 0, 0, opacity),
        accentFontColor: (opacity?: number) =>
          giveColor(255, 255, 255, opacity),
      },
      phone: {
        background: giveColor(255, 255, 255, 1.0),
        fontColor: (opacity?: number) => giveColor(0, 0, 0, opacity),
        accentColor: (opacity?: number) => giveColor(0, 0, 0, opacity),
        accentFontColor: (opacity?: number) =>
          giveColor(255, 255, 255, opacity),
      },
    },
    sideElements: {
      desktop: {
        background: (opacity?: number) => giveColor(32, 40, 40, opacity),
        // background: 'linear-gradient(to bottom, #000000, rgba(0, 0, 0, 0.9))',
        fontColor: (opacity?: number) => giveColor(255, 255, 255, opacity),
        accentFontColor: (opacity?: number) => giveColor(255, 239, 0, opacity),
        accentColor: (opacity?: number) => giveColor(0, 0, 0, opacity),
        // accentFontColor: (opacity?: number) => giveColor(255, 255, 255, opacity),
      },
      phone: {
        background: 'linear-gradient(to bottom, #000000, rgba(0, 0, 0, 0.9))',
        fontColor: (opacity?: number) => giveColor(255, 255, 255, opacity),
        accentColor: (opacity?: number) => giveColor(0, 0, 0, opacity),
        accentFontColor: (opacity?: number) =>
          giveColor(255, 255, 255, opacity),
      },
    },
    quizzes: {
      desktop: {
        background: 'transparent',
        fontColor: (opacity?: number) => giveColor(0, 0, 0, opacity),
        accentColor: (opacity?: number) => giveColor(0, 0, 0, opacity),
        accentFontColor: (opacity?: number) =>
          giveColor(255, 255, 255, opacity),
      },
    },
  },
  constants: {
    sizes: {
      desktop: {
        topBarHeight: 120,
        sideBarWidth: 50,
        bottomBarHeight: 70,
        standardButtonSize: 70,
        scrollSideBarWidth: 5,
      },
      tablet: {
        topBarHeight: 80,
        sideBarWidth: 80,
        bottomBarHeight: 72,
        standardButtonSize: 60,
      },
      phone: {
        topBarHeight: 50,
        sideBarWidth: 15,
        bottomBarHeight: 46,
        standardButtonSize: 46,
        menuButtonSize: 45,
      },
    },
  },
  fonts: {
    primary: {
      serif: 'GT-Eesti-Text-Regular',
      sansSerif: 'GT-Eesti-Text-Regular',
    },
    secondary: {
      serif: 'GT-Eesti-Text-RegularItalic',
      sansSerif: 'GT-Eesti-Text-RegularItalic',
    },
    bold: {
      serif: 'GT-Eesti-Text-Bold',
      sansSerif: 'GT-Eesti-Text-Bold',
    },
  },
  overrides: {},
}

const typoBase = typography(projectTheme)

const overrides = {
  Cover: {
    cover: {
      [`@media ${DESKTOP}`]: {},
      [`@media only screen and (orientation: landscape) and ${TABLET}`]: {},
      [`@media only screen and (orientation: portrait) and ${TABLET}`]: {
        paddingLeft: '5.2%',
      },
      [`@media ${MOBILE}`]: {
        paddingLeft: 10,
        paddingRight: 10,
      },
    },
  },
  CoverImage: {
    image: {
      [`@media ${DESKTOP}`]: {
        right: 0,
        top: 0,
        width: '70%',
      },
      [`@media only screen and (orientation: landscape) and ${TABLET}`]: {
        right: 20,
        top: 100,
        width: '67%',
      },
      [`@media only screen and (orientation: portrait) and ${TABLET}`]: {
        width: '100%',
      },
      [`@media ${MOBILE}`]: {
        width: '100%',
      },
    },
  },
  Title: {
    wrapper: {
      paddingLeft: '5.2%',
      textAlign: 'left',
      alignItems: 'flex-start',

      [`@media ${DESKTOP}`]: {},
      [`@media only screen and (orientation: landscape) and ${TABLET}`]: {},
      [`@media only screen and (orientation: portrait) and ${TABLET}`]: {
        marginBottom: 20,
        alignItems: 'flex-start',
      },
      [`@media ${MOBILE}`]: {
        alignItems: 'flex-start',
        marginBottom: 20,
      },
    },
    'title-container': {
      [`@media ${DESKTOP}`]: { top: '12.5rem' },
      [`@media ${TABLET}`]: { top: '10rem' },
      [`@media ${MOBILE}`]: {
        top: '9rem',
      },
      maxWidth: 750,
    },
    subtitle: {
      marginTop: 16,
    },
  },
  SectionTitle: {
    title: {
      ...typoBase.h2.mainContent,
      textAlign: 'left !important',
    },
    'title-container': {
      [`@media ${DESKTOP}`]: {
        padding: 0,
      },
      [`@media ${TABLET}`]: {
        padding: 0,
      },
      [`@media ${MOBILE}`]: {
        padding: 0,
      },
    },
  },
  Section: {
    title: {
      fontFamily: projectTheme.fonts.bold.sansSerif,
      [`@media ${DESKTOP}`]: {
        fontSize: '3.4375rem',
        fontWeight: 'normal',
        fontStretch: 'normal',
        fontStyle: 'normal',
        lineHeight: 0.91,
        letterSpacing: 'normal',
        textAlign: 'left',
        marginBottom: '4.3125rem',
      },
      [`@media ${TABLET} and orientation: portrait`]: {
        fontSize: `${SIZE_MULTIPLIER_SMALLER * 5.3125}rem`,
        lineHeight: 0.7,
        letterSpacing: 'unset',
      },
      [`@media ${TABLET} and orientation: landscape`]: {
        fontSize: `${SIZE_MULTIPLIER_SMALLER * 4.0625}rem`,
        lineHeight: 0.77,
        letterSpacing: 'unset',
      },
      [`@media ${MOBILE}`]: {
        fontSize: `${SIZE_MULTIPLIER_SMALLER * 3.4375}rem`,
        lineHeight: 0.73,
        letterSpacing: 'unset',
      },
    },
  },
  InlineSubcontentWidget: {
    'title-container': {
      ...typoBase.button.mainContent,
    },
  },
  InlineSubcontentQuote: {
    text: {
      ...typoBase.quotes.mainContent,
    },
    container: {
      [`@media ${TABLET} and (orientation : portrait)`]: {
        width: '100%',
      },
    },
  },
  InlineSubcontentParagraph: {
    text: {
      '& p': {
        ...typoBase.body1.mainContent,
        paddingTop: '2.5rem',
      },
      '& h2': {
        ...typoBase.h3.mainContent,
      },
    },
  },
  LazyImage: {
    container: {
      top: 'initial !important',
      left: 'initial !important',
      width: '100%',
      height: 'auto',
      position: 'relative',
      transform: 'scale(1.01)',
      objectFit: 'contain',
    },
  },
  TopBar: {
    'top-dark-overlay': {
      display: 'none',
    },
    container: {
      height: 0,
      width: 0,
    },
  },
  SubcontentTopBar: {
    topBarContainer: {
      position: 'fixed',
      right: 0,
      top: 0,
      width: 'auto',
      backgroundColor: 'transparent',
      [`@media ${DESKTOP}`]: { width: MENU_ICON_SIZE_DESKTOP },
      [`@media ${TABLET}`]: { width: MENU_ICON_SIZE_TABLET },
      [`@media ${MOBILE}`]: { width: MENU_ICON_SIZE_MOBILE },
    },
    container: { display: 'none' },
  },
  TopBarChapterNumber: {
    'chapter-number': { display: 'none' },
  },
  ChaptersBar: {
    'bar-item': {
      height: 'fit-content',
      minHeight: '70px',
      paddingBottom: '5px',
      opacity: 0.6,
      '&:hover': {
        backgroundColor: 'unset',
        opacity: 1,
      },
    },
    'bar-item-active': {
      opacity: 1,
    },
    bar: {
      backgroundColor: `${projectTheme.palette.white()} !important`,
    },
    'bar-chapter-number': {
      display: 'none',
    },
    'chapter-bar': {
      [`@media ${TABLET} and (orientation : portrait)`]: {
        display: 'none',
      },
      [`@media ${TABLET} `]: {
        paddingLeft: 10,
      },
      [`@media ${MOBILE}`]: { width: 'none' },
    },
    text: {
      fontSize: '1.125rem',
      fontWeight: 'normal',
      fontStretch: 'normal',
      fontStyle: 'normal',
      lineHeight: 1.22,
      letterSpacing: 'normal',
      '&:hover': {
        opacity: 1,
        transition: 'opacity 0.3s',
      },
    },
    'chapter-idx': {
      display: 'none',
    },
  },
  ScrollSidebar: {
    invisible: {
      opacity: 0,
      transform: 'translate(-200vw, 0)',
      transition:
        'opacity 1s cubic-bezier(0.55, 0.085, 0.68, 0.53), transform 0s 1.1s, height 1s cubic-bezier(0.55, 0.085, 0.68, 0.53)',
    },
    'scroll-sidebar': {
      display: 'none',
      justifyContent: 'center',
      opacity: 0,
      transition:
        'opacity 0.5s cubic-bezier(0.25, 0.46, 0.45, 0.94), transform 0s, height 1s cubic-bezier(0.25, 0.46, 0.45, 0.94)',
    },
    'sidebar-is-shown': {
      opacity: 1,
    },
    'current-section-title': {
      display: 'none',
    },
    'left-dark-overlay': {
      top: 0,
      height: '100%',
      opacity: 0.3,
      left: -1,
      backgroundImage:
        'linear-gradient(90deg, rgba(0, 0, 0, 0.4) 0%, #000000 4%, rgba(0, 0, 0, 0) 88%)',
      [`@media ${MOBILE}`]: {
        pointerEvents: 'none',
        display: 'block',
        width: 30,
        backgroundImage:
          'linear-gradient(to right, rgba(0, 0, 0, 0.2) 0%, rgba(255, 255, 255, 0) 100%)',
      },
    },
    'navigation-button-container': {
      display: 'none',
    },
    'chapter-number': {
      display: 'none',
    },
    'invisible-on-hover': {
      [`@media ${DESKTOP}`]: {
        opacity: 0,
        transform: 'translate(-200%, 0)',
        transition:
          'opacity 0.6s cubic-bezier(0.5, 1, 0.89, 1), transform 0s 0.7s',
      },
      [`@media ${TABLET}`]: {
        transform: 'translate(0, 0)',
        opacity: 1,
        transition: 'none',
      },
    },
    'navigation-button': {
      [`@media ${DESKTOP}`]: {
        display: 'block',
        opacity: 1,
        transition: 'opacity 0.4s cubic-bezier(0.5, 1, 0.89, 1)',
      },
      [`@media ${TABLET}`]: {
        display: 'none',
      },
    },
    'section-title': {
      position: 'absolute',
      left: 40,
      alignSelf: 'flex-start',
      writingMode: 'horizontal-tb',
      fontWeight: 500,
      textTransform: 'uppercase',
      opacity: 0.5,
      letterSpacing: '0.08rem',
      lineHeight: 1.29,
      fontFamily: projectTheme.fonts.primary.serif,
    },
    'bar-item': {
      borderRadius: '50%',
      flexGrow: 0,
      flex: 'none',
      backgroundColor: 'transparent',
      justifyContent: 'center',
      alignItems: 'center',
      position: 'relative',
      margin: '30% auto',
      marginBottom: 0,
      transition: 'height 0.4s',
      width: 16,
      height: 16,
      '&:hover': {
        '& $bar-base': {
          background: projectTheme.palette.sideElements.desktop.accentFontColor(
            0.7
          ),
          '&::before': {
            border: `solid 1px ${projectTheme.palette.sideElements.desktop.accentFontColor(
              0.7
            )}`,
            height: 16,
            width: 16,
            boxShadow: `0 0 3px ${projectTheme.palette.sideElements.desktop.accentFontColor(
              0.75
            )}`,
            transition: 'all 0.3s',
            background: 'transparent',
            // animation: '$glow-grow 3s ease-out infinite',
            // animationDelay: '0.66s',
          },
        },
        '& $section-title': {
          display: 'block',
        },
      },
      '& $filler': {
        // borderRadius: '50%',
        // backgroundColor: 'transparent',
        opacity: 0,
      },
    },
    'bar-base': {
      height: projectTheme.constants.sizes.desktop.scrollSideBarWidth,
      width: projectTheme.constants.sizes.desktop.scrollSideBarWidth,
      backgroundColor: 'transparent',
      borderRadius: '50%',
      position: 'relative',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      '&::before': {
        transition: 'all 0.3s',
        position: 'absolute',
        background: projectTheme.palette.white(0.5),
        content: "''",
        height: projectTheme.constants.sizes.desktop.scrollSideBarWidth,
        width: projectTheme.constants.sizes.desktop.scrollSideBarWidth,
        borderRadius: '50%',
        border: `solid 1px ${projectTheme.palette.white(0.5)}`,
      },
    },
    'bar-base-active': {
      borderRadius: 10,
    },
    'bar-item-active': {
      transition: 'height 0.4s',
      height: '30%',
      '& $bar-base': {
        height: '100%',
        width: projectTheme.constants.sizes.desktop.scrollSideBarWidth,
        background: projectTheme.palette.white(0.5),
        '&::before': {
          display: 'none',
        },
      },
      '&:hover': {
        '& $bar-base': {
          background: projectTheme.palette.white(0.5),
        },
      },
      '& $filler': {
        borderRadius: 10,
        left: 5.5,
        opacity: 1,
        backgroundColor: `${projectTheme.palette.white(1)} !important`,
      },
    },
    filler: {
      width: projectTheme.constants.sizes.desktop.scrollSideBarWidth,
      [`@media ${DESKTOP}`]: {
        width: projectTheme.constants.sizes.desktop.scrollSideBarWidth,
      },
      left: 0,
      '& $circle-end': {
        height: 4,
        width: 4,
        borderRadius: '50%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        border: `solid 1px ${projectTheme.palette.secondary.main}`,
        '&:after': {
          position: 'absolute',
          content: '""',
          borderRadius: '50%',
          border: `solid 1px ${projectTheme.palette.sideElements.desktop.accentFontColor(
            0.16
          )}`,
          display: 'inline-block',
          width: 15,
          height: 15,
          boxShadow: `0 0 3px ${projectTheme.palette.sideElements.desktop.accentFontColor(
            0.75
          )}`,
          animation: '$glow-grow 3s ease-out infinite',
          animationDelay: '0.66s',
        },
      },
    },
  },
  BottomBar: {
    container: {
      right: 0,
      left: 'unset',
      bottom: 100,
    },

    '& ThumbnailWithIcon': {
      display: 'none',
    },
  },
  BottomBarSlider: {
    'slider-container': {
      bottom: -50,
    },
  },
  SliderButton: {
    square: {
      width: '7px',
      height: '7px',
      borderRadius: '100%',
      backgroundColor: 'transparent',
      border: '1px solid',
    },
    active: {
      backgroundColor: 'white',
    },
    scaled: {
      [`@media ${DESKTOP}`]: {
        transform: 'unset',
      },
    },
    button: {
      [`@media ${MOBILE}`]: {
        margin: '0 0.5rem',
      },
    },
  },
  LeftButton: {
    button: {
      pointerEvents: 'auto',
      flexShrink: 0,
      height: '20px',
      width: '20px',

      [`@media ${MOBILE}, ${TABLET}`]: {
        height: '14.1px',
        width: '14.1px',
      },
    },
    arrow: {
      height: '100%',
      width: '100%',
    },
  },
  RightButton: {
    button: {
      pointerEvents: 'auto',
      flexShrink: 0,
      height: '20px',
      width: '20px',

      [`@media ${MOBILE}, ${TABLET}`]: {
        height: '14.1px',
        width: '14.1px',
      },
    },
    arrow: {
      height: '100%',
      width: '100%',
    },
  },
  ImageGallery: {
    'gallery-image-contain': {
      height: '100%',
    },
  },
  Overlay: {
    container: {
      width: '100vw',
      height: '100%',
      position: 'fixed',
      top: 0,
      left: 0,
      zIndex: 1490,
    },
  },
  SectionTextContent: {
    'content-container': {
      color: projectTheme.palette.white(),

      '@media (min-width: 768px) and (max-width: 1440px)': {
        paddingLeft: 0,
        paddingRight: 0,
      },

      '@media (min-width: 480px) and (max-width: 768px)': {
        paddingLeft: 50,
        paddingRight: 50,
      },
    },

    'text-position-left': {
      marginLeft: '0 !important',
    },
    'text-box': {
      paddingLeft: 50,
      paddingRight: 50,

      [`@media ${MOBILE}`]: {
        background: 'transparent',
        paddingLeft: 10,
        paddingRight: 10,
      },
    },
  },
  HeaderTitle: {
    'title-box': {
      color: 'inherit',
      [`@media ${MOBILE}`]: {
        color: 'inherit',
      },
    },
  },
  TabsContainer: {
    tabs: {
      display: 'none',
    },
    'top-bar': {
      display: 'none',
    },
  },
  ContentSlider: {
    'logo-container': {
      zIndex: 1490,
      '& svg': {
        minHeight: 150,
        maxWidth: 300,
        transform: 'translateY(-50%)',
      },
    },
  },
  Burger: {
    burger: {
      margin: 5,
      top: 0,
      right: 0,
      left: 'unset',
      border: '1px rgba(255, 255, 255, 1) solid',
      zIndex: 90,

      [`@media ${DESKTOP}`]: {
        width: MENU_ICON_SIZE_DESKTOP,
        height: MENU_ICON_SIZE_DESKTOP,
      },
      [`@media ${TABLET}`]: {
        width: MENU_ICON_SIZE_TABLET,
        height: MENU_ICON_SIZE_TABLET,
      },
      [`@media ${MOBILE}`]: {
        width: MENU_ICON_SIZE_MOBILE,
        height: MENU_ICON_SIZE_MOBILE,
      },
    },
  },
  SectionStickyBackground: {
    'gradient-phone-text-overlay': {
      display: 'none',
    },
    'sticky-holder': {
      [`@media ${MOBILE}, ${TABLET}`]: {
        postion: 'unset',
      },
    },
  },
  InteractiveBackground: {
    'background-overlay': {
      display: 'none',
    },
  },
  // taken from nuclear_games project
  VideoPlayer: {
    'player-wrapper': {
      // - Overlays over the video player have a "random flashing bug", especially on Safari
      // - Adding a 3d transformation forces Safari to render on the GPU and fixes this
      transform: 'translate3d(0,0,0)',
      '& video': {
        objectFit: 'contain',
        margin: '0 auto',
      },
      '& video-js': {
        width: '100%',
        minWidth: 'unset',
        minHeight: 'unset',
        backgroundColor: projectTheme.palette.black(),
        cursor: 'pointer',
        [`@media ${MOBILE}`]: {},
      },
      '&& :not(.vjs-has-started) .vjs-control-bar': {
        display: 'flex',
      },
      '&&': {
        '& .vjs-control-bar': {
          margin: 0,
          opacity: 0.7,
          backgroundImage:
            'linear-gradient(to bottom, rgba(0, 0, 0, 0), #000000)',
          [`@media ${DESKTOP}`]: {
            width: '100%',
          },
          [`@media ${MOBILE}`]: {
            top: 'unset',
            bottom: '0',
            '@media (orientation: landscape)': {
              top: 'unset',
              bottom: 0,
            },
          },
          '& .vjs-play-control': {
            width: projectTheme.constants.sizes.desktop.bottomBarHeight,
            height: '100%',
            backgroundPosition: 'center',
            backgroundSize: 'cover',
            '& > span': {
              display: 'block',
              width: '100%',
              height: '100%',
              margin: 'auto',
            },
            '& .vjs-icon-placeholder::before': {
              content: '""',
            },
            [`@media only screen and (orientation: landscape) and ${TABLET}`]: {
              width: projectTheme.constants.sizes.tablet.bottomBarHeight,
            },
            [`@media ${MOBILE}`]: {
              width: projectTheme.constants.sizes.phone.bottomBarHeight,
            },
          },
        },
        '& .vjs-text-track-cue': {
          font: `1.3rem ${projectTheme.fonts.primary.sansSerif} !important`,
          lineHeight: 1.25,
          letterSpacing: '0.05rem',
          '& > div': {
            backgroundColor: 'rgba(0, 0, 0, 0.35) !important',
          },
        },
        '& .vjs-play-control': {
          backgroundSize: '0 0 !important',
          [`@media ${DESKTOP}`]: {
            marginRight: 0,
          },
          '& > div': {
            display: 'none',
          },
          '& > span': {
            backgroundColor: 'transparent',
            backgroundSize: '40% !important',
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
            [`@media ${DESKTOP}`]: {
              left: 0,
            },
          },
        },
        '& .vjs-play-progress': {
          backgroundColor: projectTheme.palette.primary.main,
          '&::before': {
            display: 'none',
          },
        },
        '& .vjs-remaining-time-display': {
          fontFamily: projectTheme.fonts.primary.sansSerif,
          '&::after': {
            content: '"min"',
            position: 'absolute',
          },
        },
      },
    },
  },
}

projectTheme.typography = typoBase
projectTheme.overrides = overrides

export default projectTheme
